import React, { useState, useRef, useEffect } from 'react'
import { Popover as AntdPopover } from 'antd'

const Popover = ({ children, content, ...otherProps }) => {
    const [open, setOpen] = useState(false)
    const popoverRef = useRef(null)

    useEffect(() => {
        const handleFocus = () => {
            if (popoverRef.current && open) {
                const popoverContent = document.querySelector('.ant-popover-inner-content')
                if (popoverContent) {
                    popoverContent.setAttribute('tabIndex', '-1')
                    popoverContent.focus()
                    popoverContent.onkeydown = handleKeyDown
                }
            }
        }

        document.addEventListener('click', handleFocus)
        return () => {
            document.removeEventListener('click', handleFocus)
        }
    }, [open])

    const handleOpenChange = open => {
        setOpen(open)
    }

    const handleKeyDown = event => {
        if (event.keyCode === 27) {
            // Escape key
            setOpen(false)
        }
    }

    return (
        <AntdPopover
            content={<div ref={popoverRef}>{content}</div>}
            open={open}
            onOpenChange={handleOpenChange}
            {...otherProps}
        >
            {children}
        </AntdPopover>
    )
}

export default Popover
